import React from 'react'
import { useDeleteRequest } from '../hooks/request'
import { useModal } from '../hooks/modal'
import Loader from './common/Loader'

import { getDateTime } from '../utils/date'
import { ANIMAL_TYPE_DETAIL } from '../urls'
import AnimalTypeUpdate from './AnimalTypeUpdate'

export default function AnimalTypeItem({ item, animalTypes, index }) {
    const animalTypeRemove = useDeleteRequest({ url: ANIMAL_TYPE_DETAIL.replace('{id}', item.id) })
    const [showUpdateModal, setShowUpdateModal] = useModal(
        <AnimalTypeUpdate
            item={item}
            onSuccess={() => {
                animalTypes.request()
                setShowUpdateModal()
            }}
            onCancel={() => setShowUpdateModal()}
        />,
    )

    async function onDelete() {
        if (global.confirm('Сиз чинакамдан ўчиришни истайсизми?')) {
            await animalTypeRemove.request()
            animalTypes.request()
        }
    }

    return (
        <tr>
            <td>{index + 1}</td>
            <td>{item.name}</td>

            <td>{getDateTime(item.createdAt)}</td>

            <td>
                <div className="is-pulled-right">
                    {!animalTypeRemove.loading ? <i onClick={onDelete} className="icon pointer ion-md-trash" /> : <Loader className="icon" />}

                    <i onClick={showUpdateModal} className="icon pointer ion-md-create" />
                </div>
            </td>
        </tr>
    )
}
